import React from 'react';

function NavHeadingUnderline() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117 4" fill="none" width='100%'>
            <path d="M0.844466 3.00985C19.0544 2.84924 37.4824 2.16282 55.6924 2.00221C72.1541 1.85702 88.9996 1.57756 105.462 1.4955C108.888 1.47842 111.999 1.22105 115.386 1.6743" stroke="black" strokeWidth="1.4" strokeLinecap="round" />
        </svg >
    );
}

export default NavHeadingUnderline